import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, set } from "@ember/object"
import { inject as service } from "@ember/service"
import type { AiValueEditor } from "cc-frontend/lib/ai/ai-value-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor";
import type LessonEditor from "cc-frontend/services/lesson-editor"

@tagName("")
export default class CardStackTitle extends Component {
  modelsNeededForFirstEdit!: ModelsNeededForFirstEdit
  registerEditor?: (editor: AiValueEditor<unknown>) => void
  cardStackId!: string
  value!: string

  hasFocus: boolean = false

  @service lessonEditor!: LessonEditor

  @action
  onTitleEdited(value) {
    this.lessonEditor.editTitle(this.modelsNeededForFirstEdit, this.cardStackId, value, false)
  }

  @action
  onFinishedEditingTitle(value, originalValue) {
    this.lessonEditor.finishEditingTitle(
      this.modelsNeededForFirstEdit,
      this.cardStackId,
      value,
      originalValue
    )
  }

  @action
  onFocusIn() {
    set(this, "hasFocus", true)
  }

  @action
  onFocusOut() {
    set(this, "hasFocus", false)
  }
}
